// ════════════════════════════════════════════════════════════════════
// Glass-i — Stage SCAN-6 · Ingest Monitor API client.
// Base: /api/erp/production/scan-ingest
//
//   list   → { items, page, limit, total, totalIsCapped, summary, window, filters }
//   remove → { deleted, deletedIds, skipped: [{ id, status, reason }] }
//
// `remove` is a POST, not a DELETE: the ids travel in a body, and a DELETE
// with a request body is under-specified in HTTP (proxies drop it).
// Master-only server-side; APPLIED records are refused there, not here.
// ════════════════════════════════════════════════════════════════════

import client from '../../../../api/client';

const BASE = '/api/erp/production/scan-ingest';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : (resp ? resp.data : null);
}

export const scanIngestApi = {
  // params: { page, limit, status (string | string[]), deviceId,
  //           departmentCode, barcode, batchId, from, to }
  // The window defaults to the last 7 days server-side and is capped at 92 —
  // scan_ingest_records is partitioned on received_at, so an unbounded query
  // would read every partition.
  list: (params) => client.get(BASE, { params }).then(unwrap),
  remove: (ids) => client.post(`${BASE}/delete`, { ids }).then(unwrap)
};

export default scanIngestApi;
